<template>
    <div class="page-container">

        <div class="section section-full-screen">
            <div class="container">
                
                <div class="center-page">
                    <h2 class="title">404 Page Not Found.</h2>
                    <h2 class="title">頁面不存在</h2>

                    <b-button variant="primary" class="more-detail-button scrollactive-item" :to="{ name: 'Home' }">
                        回首頁
                    </b-button>
                </div>
                
            </div>
        </div>

    </div>
</template>

<script>

export default {
    data () {
        return {
        }
    },
    mounted ()
    {

    },
    methods: {


    },
}
</script>

<style lang="scss" scoped>

.section-full-screen
{
    background-color: rgba(216, 205, 169, 0.5);
}

.center-page
{
    text-align: center;
    margin-top: 25vh;
}

.more-detail-button
{
    padding: 15px 30px;
    font-size: 1.2rem;

    i {
        margin-left: 10px;
    }
}

</style>